import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import {
  DATA_TABLE_SOURCE_RENTLINX_LEAD_NOTES,
  DATA_TABLE_VIEW_ID_PARTNER_NOTES_ALL,
} from 'common/dataTableConstants';

import { SR_API_ACTION_RENTLINX_LEAD_SHARE_NOTE } from 'api/actionTypes';

import postWithState from 'client/actions/postWithState';

import SrNotesList, { SR_RENTLINX_LEAD_NOTES } from 'client/components/SrNotesList';
import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrCard from 'client/components/SrCard/SrCard';
import SrCreateNoteForm, {
  SR_CREATE_NOTE_FORM_THEME_GREYCLIFF,
} from 'client/components/SrCreateNoteForm';
import SrDataTableConnected from 'client/components/SrDataTableConnected';

const SrRentlinxLeadNotes = ({
  height,
  rentlinxLeadId,
  currentUser,
  onUpdate,
  listingIds,
  dispatch,
}) => {
  const onClickShareNote = useCallback(
    (rentlinxLeadNote) => {
      return dispatch(postWithState, {
        action: SR_API_ACTION_RENTLINX_LEAD_SHARE_NOTE,
        payload: {
          rentlinxLeadNoteId: rentlinxLeadNote.id,
          listingIds: rentlinxLeadNote.rentlinxLeadSharedListingNotes?.length > 0 ? [] : listingIds,
        },
      });
    },
    [listingIds, dispatch],
  );

  return (
    <SrCard overflow="auto" height={height}>
      <SrText
        font="greycliff"
        fontSize="18px"
        weight="800"
        color="blueGreycliff"
        display="block"
        paddingBottom="20px"
      >
        Lead Notes
      </SrText>
      <SrDataTableConnected
        itemsPropName="notes"
        dataSource={DATA_TABLE_SOURCE_RENTLINX_LEAD_NOTES}
        rootViewId={DATA_TABLE_VIEW_ID_PARTNER_NOTES_ALL}
        initialViewSettings={{
          sort: {
            createdDate: 'desc',
          },
          filter: {
            rentlinxLeadId,
          },
        }}
      >
        {({ notes, reloadItems, onInfiniteScrollWrapperRef }) => {
          const reloadDataTable = (noteId) => {
            reloadItems({
              count: 1,
              filter: { 'rentlinxLeadNotes.id': noteId },
            });

            if (onUpdate) {
              onUpdate();
            }
          };
          return (
            <>
              <SrBox paddingBottom="10px">
                <SrCreateNoteForm
                  rentlinxLeadId={rentlinxLeadId}
                  dispatch={dispatch}
                  theme={SR_CREATE_NOTE_FORM_THEME_GREYCLIFF}
                  reloadDataTable={reloadDataTable}
                />
              </SrBox>
              <div ref={onInfiniteScrollWrapperRef}>
                <SrNotesList
                  type={SR_RENTLINX_LEAD_NOTES}
                  openedInModal
                  notes={notes}
                  dispatch={dispatch}
                  reloadDataTable={reloadDataTable}
                  currentUser={currentUser}
                  onClickShareNote={listingIds ? onClickShareNote : null}
                />
              </div>
            </>
          );
        }}
      </SrDataTableConnected>
    </SrCard>
  );
};

SrRentlinxLeadNotes.propTypes = {
  height: PropTypes.string,
  rentlinxLeadId: PropTypes.oneOfType([PropTypes.string.isRequired, PropTypes.number.isRequired])
    .isRequired,
  currentUser: PropTypes.object.isRequired,
  onUpdate: PropTypes.func,
  dispatch: PropTypes.func.isRequired,
  listingIds: PropTypes.array,
};

SrRentlinxLeadNotes.displayName = 'SrRentlinxLeadNotes';

export default SrRentlinxLeadNotes;
